import { render, staticRenderFns } from "./Kits.vue?vue&type=template&id=5d4fab3c&scoped=true"
import script from "./Kits.vue?vue&type=script&lang=js"
export * from "./Kits.vue?vue&type=script&lang=js"
import style0 from "./Kits.vue?vue&type=style&index=0&id=5d4fab3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fab3c",
  null
  
)

export default component.exports